import { render, staticRenderFns } from "./GoodsDetailsItems.vue?vue&type=template&id=05a34b58&"
import script from "./GoodsDetailsItems.vue?vue&type=script&lang=js&"
export * from "./GoodsDetailsItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
